<template>
  <v-container fluid>
    <div class="d-flex flex-column">
      <v-row class="pl-2 pr-2">
        <v-col
          cols="7"
        >
          <div class="title">
            <v-edit-dialog
              :return-value="dashboard.name"
              @open="dashboardOld.name = dashboard.name"
              @save="ApplyEditName"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <div
                    class="editable-title text-truncate pr-4"
                    v-on="on"
                  >
                    {{ dashboard.name }}
                    <v-icon
                      class="edit-icon"
                      small
                      color="primary"
                      :style="{'position':'relative', 'top':'0px'}"
                    >
                      mdi-circle-edit-outline
                    </v-icon>
                  </div>
                </template>
                <span>Click to edit</span>
              </v-tooltip>

              <template v-slot:input>
                <v-text-field
                  v-model="dashboard.name"
                  label="Dashboard's title"
                  placeholder="Enter dashboard title..."
                  single-line
                />
              </template>
            </v-edit-dialog>
          </div>
        </v-col>
        <v-col
          cols="5"
          class="text-right"
        >
          <template v-if="isEditing.widgets">
            <elements-browser
              :btn-class="'mr-2'"
              :project="project"
              text
              color="info"
              small
              @add="createWidgets"
            >
              <v-icon
                left
              >
                mdi-plus
              </v-icon>Add visualization
            </elements-browser>
            <v-btn
              small
              text
              color="primary"
              class="mr-2"
              @click="applyChanges"
            >
              <v-icon
                left
              >
                mdi-checkbox-marked-circle-outline
              </v-icon>
              Apply changes
            </v-btn>
          </template>
          <v-btn
            v-if="!isEditing.widgets"
            text
            outlined
            class="mr-2"
            color="red"
            @click="destroy"
          >
            <v-icon
              left
            >
              mdi-delete-outline
            </v-icon>
            Delete
          </v-btn>
          <v-btn
            v-if="! isEditing.widgets && dashboard.widgets.length>0"
            class="mr-3"
            @click="handleEdit('widgets')"
          >
            <v-icon
              left
            >
              mdi-pencil-outline
            </v-icon>
            Edit
          </v-btn>
          <v-btn
            v-if="isEditing.widgets"
            class="mr-3"
            @click="handleCancelEdit('widgets')"
          >
            Cancel
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="flex-grow-1">
        <v-col v-if="!isInitiated">
          <loading-dashboard-placeholder />
        </v-col>
        <v-col
          v-else-if="dashboard.widgets.length<=0"
          class="empty-placeholder"
        >
          <v-icon>mdi-monitor-dashboard</v-icon>
          <div class="title">
            Your dashboard is empty
          </div>
          <div class="title-details">
            Start populating your dashboard with tables, charts, counter...
          </div>
          <elements-browser
            :project="project"
            :btn-class="'outlined'"
            @add="createWidgets"
          >
            <v-icon left>
              mdi-plus
            </v-icon>Add visualization
          </elements-browser>
        </v-col>
        <v-col v-else>
          <grid-layout
            v-if="renderLayout"
            responsive
            :layout.sync="dashboard.widgets"
            :col-num="12"
            :row-height="35"
            :margin="[10, 10]"
            auto-size
            :is-draggable="isEditing.widgets"
            :is-resizable="isEditing.widgets"
            :use-css-transforms="true"
          >
            <grid-item
              v-for="(el,el_index) in dashboard.widgets"
              :key="el.i"
              :x="el.x"
              :y="el.y"
              :w="el.w"
              :h="el.h"
              :i="el.i"
            >
              <dashboard-element
                fill-parent
                :removable="isEditing.widgets"
                :editable="isEditing.widgets"
                :project="project"
                :element="el.visualization"
                @edit="(e)=>{applyEditElement(el_index,e)}"
                @remove="removeElement(el_index)"
              />
            <!-- <div> [{{el.x}}-{{el.y}}] | [{{el.w}}-{{el.h}}] </div> -->
            </grid-item>
          </grid-layout>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>

  import LoadingDashboardPlaceholder from './../../../../UIComponents/Placeholders/LoadingDashboardPlaceholder'

  import VueGridLayout from 'vue-grid-layout'

  import ElementsBrowser from './ElementsBrowser'

  import Element from './../../../../UIComponents/Dashboard/Element'

  import DashboardService from './services/DashboardService'

  import VisualisationService from './services/VisualizationService.js'

  import { DEFAULT_SIZES } from './constants/GridLayoutDefaultConstants'

  export default {
    components: {
      LoadingDashboardPlaceholder,
      DashboardElement: Element,
      ElementsBrowser: ElementsBrowser,
      GridLayout: VueGridLayout.GridLayout,
      GridItem: VueGridLayout.GridItem,
    },
    props: {
      identifier: {
        type: String,
        default: null,
      },
    },
    data () {
      return {
        renderLayout: true,
        isInitiated: false,
        isEditing: {
          widgets: false,
          name: false,
        },
        project: this.$route.params.project,
        actionHistory: [],
        dashboardOld: {
          name: '',
          widgets: [],
        },
        dashboard: {
          name: this.$route.params.dashboard,
          lebels: [],
          description: '',
          widgets: [],
          is_global: false,
        },
        bufferedIndex: 0,
      }
    },
    mounted () {
      const t = this
      t.get()
    },
    methods: {
      handleEdit (attr) {
        this.dashboardOld[attr] = _.cloneDeep(this.dashboard[attr])
        this.isEditing[attr] = !this.isEditing[attr]
        this.$nextTick(() => {
          if (attr == 'name') { this.$refs['edit-name-text-field'].focus() }
        })
        this.bufferedIndex = this.getBufferizedIndex()
      },
      handleCancelEdit (attr) {
        this.renderLayout = false
        this.isEditing[attr] = !this.isEditing[attr]
        this.$set(this.dashboard, attr, _.cloneDeep(this.dashboardOld[attr]))
        this.$nextTick(() => {
          this.renderLayout = true
        })
      },
      applyChanges () {
        const self = this
        _.forEach(this.dashboardOld.widgets, ow => {
          const foundIndex = _.findIndex(self.dashboard.widgets, { id: ow.id })
          if (foundIndex < 0) {
            DashboardService.delete_widget(this, ow).then((res) => {
              // Update widget i, reorganized by the server
              for (const widget in this.dashboard.widgets) { this.dashboard.widgets[widget].i = res.new_i[this.dashboard.widgets[widget]] }
            })
            return true
          }
          if (
            _.filter(['i', 'w', 'h', 'x', 'y'], (key) => { return self.dashboard.widgets[foundIndex][key] !== ow[key] }).length > 0
          ) {
            DashboardService.update_widget(this, self.dashboard.widgets[foundIndex])
          }
          if (
            _.filter(['options', 'label', 'type'], (key) => { return self.dashboard.widgets[foundIndex].visualization[key] !== ow.visualization[key] }).length > 0
          ) {
            VisualisationService.update(this, self.dashboard.widgets[foundIndex].visualization)
          }
        })
        this.isEditing.widgets = false
      },
      ApplyEditName () {
        const self = this
        DashboardService.update(self, { name: self.dashboard.name }, self.dashboardOld.name).then(res => {
          self.dashboardOld.name = _.clone(self.dashboard.name)
          self.$store.commit('push', { msg: "Dashboard's name updated", color: 'secondary' })
          self.$router.replace(`/projects/${self.$route.params.project}/view/dashboard/${self.dashboard.name}`).catch(() => {})
        }).catch(() => {
          self.dashboard.name = _.clone(self.dashboardOld.name)
        })
      },
      applyEditElement (index, el) {
        this.dashboard.widgets[index].visualization.type = el.type
        this.dashboard.widgets[index].visualization.label = el.label
        this.dashboard.widgets[index].visualization.options = el.options
      },
      removeElement (index) {
        const self = this
        this.$store.commit('confirm', {
          message: 'Do you really want to delete this widget ?',
          title: 'Warning',
          color: 'warning',
          onCancel: () => {},
          onConfirm: () => {
            self.dashboard.widgets.splice(index, 1)
          },
        })
      },
      updateWidget (widget) {
        DashboardService.update_widget(this, widget)
      },
      createWidgets (els) {
        const self = this
        _.map(els, async (e, eIndex) => {
          const gridParams = {
            x: 0,
            y: 0,
            w: DEFAULT_SIZES[e.type].w,
            h: DEFAULT_SIZES[e.type].h,
            minH: DEFAULT_SIZES[e.type].minH,
            minW: DEFAULT_SIZES[e.type].minW,
            i: this.bufferedIndex,
            visualization_id: e.id,
          }
          _.map(gridParams, (gp, i) => {
            e[i] = gp
          })
          await DashboardService.create_widget(self, self.dashboard, e).then(
            res => {
              self.dashboard.widgets.push(res.data)
              self.dashboardOld.widgets.push(res.data)
              this.bufferedIndex = this.getBufferizedIndex()
            }
          )
        })
      },
      destroy () {
        const self = this
        this.$store.commit('confirm', {
          message: 'Do you really want to delete this dashboard ?',
          title: 'Warning',
          color: 'warning',
          onCancel: () => {},
          onConfirm: () => {
            DashboardService.delete(self, self.dashboard.id).then(res => {
              self.$emit('delete')
              self.$emit('close')
            })
          },
        })
      },
      getBufferizedIndex () {
        /**
         * Get the higher widget's i
         */
        let max = 0
        this.dashboard.widgets.forEach((widget) => {
          console.log(widget)
          if (widget.i >= max) { max = widget.i + 1 }
        })
        console.log(`Max is ${max}`)
        return max
      },
      get () {
        const self = this
        DashboardService.get(self, self.identifier || self.$route.params.dashboard).then(res => {
          _.map(res.data.widgets, w => {
            w.minH = DEFAULT_SIZES[w.visualization.type].minH
            w.minW = DEFAULT_SIZES[w.visualization.type].minW
          })
          self.dashboard = _.cloneDeep(res.data)
          self.dashboardOld.widgets = _.cloneDeep(res.data.widgets)
        }).finally(() => {
          this.isInitiated = true
          this.bufferedIndex = this.getBufferizedIndex()
        })
      },
    },
  }
</script>

<style scoped>
.title {
  font-weight: 300;
}

.empty-placeholder {
  margin-top: 12vh;
  text-align: center;
}

.empty-placeholder > .v-icon {
  color: lightgrey;
  font-size: 75px;
}

.empty-placeholder > .title-details {
  font-size: 18px !important;
  font-weight: 300;
  margin: 10px 0px;
  color: lightgrey;
}

.empty-placeholder > .title {
  margin-top: 10px;
  font-size: 35px !important;
  font-weight: 300;
  color: lightgrey;
}

.float-card {
  position: fixed;
  /* bottom:70px; */
  bottom: 20px;
  width: 95%;
  left: 0;
  right: 0;
  margin: auto;
}

.pb-90 {
  padding-bottom: 90px;
}
</style>
<style>
.vue-grid-item.vue-grid-placeholder {
  background-color: lightgrey !important;
}
.editable-title{
    padding:5px;
    border-radius:5px;
}
.editable-title:hover{
    background-color:#213c643b;
    transition: 1s background;
}
.editable-title{
    max-width:100%;position:relative;display: inline-block;

}
.v-small-dialog__activator__content{
    width:100%;
}
i.edit-icon{
    position: absolute;
    right: 0px;
    top: 14px;
}
</style>
